import { useProfile } from 'context/profile';
import Episode from 'models/Episode';
import LocationEpisode from 'models/LocationEpisode';
import LocationEpisodeSummary from 'models/LocationEpisodeSummary';
import { Accessor } from 'models/Profile';

type AccessGuardProps = {
  accessor: Accessor | Accessor[];
  strictMode?: boolean;
  fallback?: React.ReactNode;
  skipPermissionCheck?: boolean;
  children: React.ReactNode;
  locationEpisode?: LocationEpisode | LocationEpisodeSummary;
  episode?: Episode;
};

export default function AccessGuard({
  accessor,
  strictMode = true,
  fallback = <></>,
  skipPermissionCheck = false,
  children,
  locationEpisode,
  episode,
}: AccessGuardProps) {
  const { profile } = useProfile();

  const accessors = Array.isArray(accessor) ? accessor : [accessor];

  const isPermissionGranted = strictMode
    ? profile.hasAll(accessors, { episode, locationEpisode })
    : profile?.hasAny(accessors, { episode, locationEpisode });

  return skipPermissionCheck || isPermissionGranted ? children : fallback;
}
